import { Action } from '@ngrx/store';
import { ProcessModel } from '../process.model';
import { JobSourcingActionTypes } from '../../../job-sourcing-module/actions/job-sourcing.actions';

export enum ProcessActionTypes {
  LOAD_JOB_PROCESS = '[JobProcess] Load Job Process',
  LOAD_JOB_PROCESS_SUCCESS = '[JobProcess] Load Job Process Success',
  UPDATE_JOB_PROCESS_STEP = '[JobProcess] Update Job Process Step',

  UPDATE_JOB_PROCESS = '[JobProcess] Update Job Process',
  UPDATE_JOB_PROCESS_SUCCESS = '[JobProcess] Update Job Process Success',
  CREATE_JOB_PROCESS = '[JobProcess] Create Job Process',
  CREATE_JOB_PROCESS_SUCCESS = '[JobProcess] Create Job Process Success',
}

export class LoadJobProcess implements Action {
  readonly type = ProcessActionTypes.LOAD_JOB_PROCESS;

  constructor(public payload: { jobId: number }) {}
}

export class LoadJobProcessSuccess implements Action {
  readonly type = ProcessActionTypes.LOAD_JOB_PROCESS_SUCCESS;

  constructor(public payload: { process: ProcessModel }) {}
}

export class UpdateJobProcessStep implements Action {
  readonly type = ProcessActionTypes.UPDATE_JOB_PROCESS_STEP;

  constructor(public payload: { id: number; changes }) {}
}

export class UpdateJobProcess implements Action {
  readonly type = ProcessActionTypes.UPDATE_JOB_PROCESS;

  constructor(public payload: { jobId: number }) {}
}

export class CreateJobProcess implements Action {
  readonly type = ProcessActionTypes.CREATE_JOB_PROCESS;

  constructor(public payload: { jobId: number }) {}
}

export class UpdateJobProcessSuccess implements Action {
  readonly type = ProcessActionTypes.UPDATE_JOB_PROCESS_SUCCESS;

  constructor(public payload: { process: ProcessModel }) {}
}

export class CreateJobProcessSuccess implements Action {
  readonly type = ProcessActionTypes.CREATE_JOB_PROCESS_SUCCESS;

  constructor(public payload: { process: ProcessModel }) {}
}

export type ProcessActions =
  | UpdateJobProcessStep
  | LoadJobProcessSuccess
  | LoadJobProcess
  | CreateJobProcess
  | CreateJobProcessSuccess
  | UpdateJobProcess
  | UpdateJobProcessSuccess;
